import { Loader, SectionMessage } from "@certn/cascadia-react";
import { usePeopleAPI } from "@certn/legacy-api";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { DashboardCards } from "./DashboardCards";
import { DashboardEmpty } from "./DashboardEmpty";
import { HistoryCards } from "./HistoryCards";
import { SubmitCheckModal } from "./SubmitCheckModal";
import { useDocumentTitle } from "../../hooks/api/useDocumentTitle";
import { useNetworkState } from "../../hooks/useNetworkState";

export function DashboardPage() {
  const { t } = useTranslation();
  useDocumentTitle(`Certn ${t("Dashboard")}`);
  const { data: applications, isLoading: applicationsLoading } = usePeopleAPI(
    "/internal/people/applicant/list/"
  );
  const location = useLocation();
  const [showSuccessModal, setShowSuccessModal] = useState(
    location.state?.showSuccessModal ?? false
  );
  const { isOnline } = useNetworkState();

  if (applicationsLoading) {
    return <Loader type="spinner" size="default" overlay />;
  }

  if (applications?.length === 0) {
    return <DashboardEmpty />;
  }

  return (
    <>
      {!isOnline && (
        <SectionMessage
          sectionTitle={t("Oops! You're currently offline")}
          type="danger"
          icon="error"
        >
          <Trans>Please check your internet connection</Trans>
        </SectionMessage>
      )}
      <DashboardCards />
      <HistoryCards />
      <SubmitCheckModal
        show={showSuccessModal}
        provideFeedback={false}
        setShowSuccessModal={setShowSuccessModal}
      />
    </>
  );
}
